export enum LogUserEventType {
  LOGIN = 'login',
  LOGOUT = 'logout',
  BREAK_START = 'break_start',
  BREAK_END = 'break_end',
}
